import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => {
  const [roleWiseAccess, setRoleWiseAccess] = useState({});

  return (
    <ErrorBoundary {...rest}>
      <Route
        {...rest}
        render={props => {
          let date1 = JSON.parse(localStorage.getItem("logintime"));
          date1 = new Date(date1);
          let date2 = new Date();
          if (date1) {
            if (date1.getDate() < date2.getDate()) {
              localStorage.removeItem("authUser");
              localStorage.removeItem("auth_token");
              localStorage.removeItem("user_info");
              localStorage.removeItem("user_id");
              localStorage.removeItem("logintime");
            }
          }

          if (isAuthProtected && !localStorage.getItem("authUser")) {
            return (
              <Redirect
                to={{ pathname: "/login", state: { from: props.location } }}
              />
            );
          }

          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }}
      />
    </ErrorBoundary>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    console.log("Error:", error);
    // localStorage.removeItem("authUser");
    // localStorage.removeItem("auth_token");
    // localStorage.removeItem("user_info");
    // localStorage.removeItem("user_id");
    // localStorage.removeItem("logintime");
    // window.location.href = "/";
    return;
  }

  render() {
    return this.props.children;
  }
}

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
};

export default AppRoute;
